<footer class="ftco-footer ftco-bg-dark ftco-section">
    <div class="container">
        <div class="row mb-5">

            <div class="col-md-6 col-lg-3">
                <div class="ftco-footer-widget mb-4">
                    <h2 class="ftco-heading-2"><i class="fas fa-utensils"></i> La Nopalera</h2>
                    <p>Somos un restaurante ubicado en Ezequiel Montes, Qro. donde podrás disfrutar con tu familia y amigos de una gran variedad de cortes y platillos deliciosos.</p>
                    <p><strong>Domicilio:</strong> Agustín Melgar 75, Centro, 76650 Ezequiel Montes, Qro.</p>

                </div>
            </div>
            <div class="col-md-6 col-lg-3">
                <div class="ftco-footer-widget mb-4">
                    <h2 class="ftco-heading-2"><i class="fas fa-map-marker-alt"></i> Contácto</h2>
                    <p>
                        Teléfono y Whatsapp:<br> <span class="text"><i class="fab fa-whatsapp mr-1" style="color: rgb(12, 170, 33)"></i> <a href="https://wa.me/{{ empresa.whatsapp }}" target="_blank">{{ empresa.phone }}</a></span>
                    </p>
                </div>
                <div class="ftco-footer-widget">
                    <h2 class="ftco-heading-2"><i class="fas fa-map-marker-alt"></i> Ubicación</h2>
                    <div class="text-center mb-2" style="cursor: pointer;">
                        <img (click)="showModal('modalUbicacion')" src="assets/images/background/bg_local_fachada.jpg" width="80%" alt="Ubicación" class="img-thumbnail">
                    </div>
                    <p class="text-center caption">
                        <a href="https://g.page/RestauranteLaNopalera" target="_blank"> <i class="fas fa-map-marker-alt mr-1"> </i>Ver en Google Maps</a>
                    </p>
                </div>
            </div>

            <div class="col-md-6 col-lg-3">
                <div class="ftco-footer-widget mb-4">
                    <h2 class="ftco-heading-2"><i class="far fa-clock"></i> Horario</h2>
                    <ul class="list-unstyled open-hours">
                        <li class="d-flex"><span>Lunes</span><span>9:00 - 18:00</span></li>
                        <li class="d-flex"><span>Martes</span><span>9:00 - 18:00</span></li>
                        <li class="d-flex"><span>Miércoles</span><span>CERRADO</span></li>
                        <li class="d-flex"><span>Jueves</span><span>9:00 - 18:00</span></li>
                        <li class="d-flex"><span>Viernes</span><span>9:00 - 18:00</span></li>
                        <li class="d-flex"><span>Sábado</span><span>9:00 - 18:00</span></li>
                        <li class="d-flex"><span class="text-warning">Desayuno Buffet los Domingos</span></li>
                        <li class="d-flex"><span>Domingo</span><span>8:00 - 14:00</span></li>
                    </ul>
                    <h2><i class="far fa-thumbs-up"></i> Redes Sociales</h2>
                    <ul class="ftco-footer-social list-unstyled float-md-left float-lft mb-5">
                        <li class=""><a href="https://www.facebook.com/restaurantelanopalera" target="_blank"><span class="icon-facebook"></span></a></li>
                        <li class=""><a href="https://www.instagram.com/restaurantelanopalera" target="_blank"><span class="icon-instagram"></span></a></li>
                    </ul>
                </div>
            </div>

            <div class="col-md-6 col-lg-3">
                <div class="ftco-footer-widget mb-4">

                    <h2 class="ftco-heading-2"><i class="fas fa-shopping-cart"></i> Método de Pago</h2>
                    <p>Por el momento solo aceptamos <strong>Pagos en Efectivo</strong></p>

                    <h2 class="ftco-heading-2 mt-5 mb-3"><i class="fas fa-bullhorn"></i> Promociones</h2>
                    <p>Para conocer nuestras promociones vigentes, visíta nuestra <a href="https://www.facebook.com/restaurantelanopalera" target="_blank">página de facebook</a> o llámanos al número <span class="text"><i class="fab fa-whatsapp mr-1" style="color: rgb(12, 170, 33)"></i>
                        <a href="https://wa.me/{{ empresa.whatsapp }}" target="_blank">{{ empresa.phone }}</a></span></p>

                </div>
            </div>

        </div>
        <div class="row">
            <div class="col-md-12 text-center">

                <p>
                    <!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. -->
                    Copyright &copy;
                    <script>
                        document.write(new Date().getFullYear());
                    </script> Todos los derechos reservados | Creado por <a href="https://cerovirtual.com" target="_blank">CeroVirtual.com</a>
                    <!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. -->
                </p>
            </div>
        </div>
    </div>
</footer>


<div id="modalUbicacion" class="modal">
    <span class="close" (click)="hideModal('modalUbicacion')">&times;</span>
    <img class="modal-content" src="assets/images/ubicacion/mapa.jpg" id="img01" (click)="hideModal('modalUbicacion')">
    <div class="caption">
        <h4> Click para ver en <a href="https://g.page/RestauranteLaNopalera" target="_blank"><i class="fas fa-map-marker-alt"></i> Google Maps</a> </h4>
    </div>
</div>
